
import * as React from "react"
import { useMediaQuery, MEDIA_QUERIES } from "./useMediaQuery";

/**
 * Check if device is mobile considering both portrait and landscape modes
 * Mobile layout is used for screens < 1024px width
 * 
 * Uses CSS Media Queries via matchMedia to avoid forced reflows
 * (no direct reads of window.innerWidth/innerHeight)
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MEDIA_QUERIES.MOBILE);
}

/**
 * Detect if device is specifically in mobile landscape mode
 * (width < 1024px AND landscape orientation AND limited height)
 * 
 * Uses CSS Media Queries to avoid forced reflows
 */
export function useIsLandscapeMobile(): boolean {
  return useMediaQuery(MEDIA_QUERIES.MOBILE_LANDSCAPE);
}

/**
 * Check if screen is small (< 768px) - useful for chart density
 */
export function useIsSmallScreen(): boolean {
  return useMediaQuery(MEDIA_QUERIES.SMALL_SCREEN);
}
